// assets/ecomific-globo-region-bridge.js
// Data-layer Globo adapter:
// - sets region-aware excludeTags via official config hook
// - optionally reloads collection/search pages when region changes so Globo re-initializes on correct dataset

(function () {
  'use strict';

  if (window.__ECOMIFIC_GLOBO_REGION_BRIDGE__) return;
  window.__ECOMIFIC_GLOBO_REGION_BRIDGE__ = true;

  var MODULE = 'globo-region-bridge';
  var REGION_LS_KEYS = ['ecomific_region', 'region'];
  var REGION_COOKIE_KEYS = ['ecomific_region', 'region'];
  var EAST_EXCLUDE = 'west-only';
  var WEST_EXCLUDE = 'east-only';
  var FALLBACK_STATIC_EXCLUDES = ['hidden'];
  var RELOAD_TTL_MS = 15000;
  var RELOAD_KEY_PREFIX = 'ecomific_globo_region_reload:';
  var GLOBO_API_PATH_MATCHERS = ['/api/apiFilter', '/api/apiSearch', '/api/search'];
  var GLOBO_HOST_MATCHER = /(?:^|\.)globo\.io$/i;

  var currentRegion = readRegion();
  var regionAtLoad = currentRegion;
  var baseExcludeTags = null;
  var fetchPatched = false;
  var pendingHideTimer = null;
  var initialGridRevealArmed = false;
  var initialGridRevealDone = false;
  var initialGridObserver = null;
  var globoInFlightRequests = 0;
  var globoSawRequest = false;
  var reloadScheduled = false;
  var lastApply = {
    at: '',
    reason: '',
    region: '',
    requiredTag: '',
    excludeTags: []
  };
  var lastMutation = {
    at: '',
    region: '',
    requiredTag: '',
    excludeTags: [],
    url: ''
  };

  function isDebugEnabled() {
    if (window.ECOMIFIC_DEBUG === true || window.ecomificDebug === true || window.__ecomificDebug === true) {
      return true;
    }
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get('ecomificDebug') === '1';
    } catch (e) {
      return false;
    }
  }

  function logInfo(msg, data) {
    if (!isDebugEnabled() || !window.console || !console.info) return;
    if (typeof data === 'undefined') {
      console.info('[ecomific][info] ' + MODULE + ': ' + msg);
      return;
    }
    console.info('[ecomific][info] ' + MODULE + ': ' + msg, data);
  }

  function normalizeRegion(value) {
    if (typeof value !== 'string') return '';
    var normalized = value.trim().toLowerCase();
    return normalized === 'east' || normalized === 'west' ? normalized : '';
  }

  function normalizeTag(value) {
    if (typeof value !== 'string') return '';
    return value.trim().toLowerCase();
  }

  function getCookie(name) {
    if (!name) return '';
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readRegionFromLs() {
    try {
      if (!window.localStorage) return '';
      for (var i = 0; i < REGION_LS_KEYS.length; i += 1) {
        var next = normalizeRegion(window.localStorage.getItem(REGION_LS_KEYS[i]));
        if (next) return next;
      }
    } catch (e) {}
    return '';
  }

  function readRegionFromCookie() {
    for (var i = 0; i < REGION_COOKIE_KEYS.length; i += 1) {
      var next = normalizeRegion(getCookie(REGION_COOKIE_KEYS[i]));
      if (next) return next;
    }
    return '';
  }

  function readRegion() {
    return readRegionFromLs() || readRegionFromCookie();
  }

  function uniqueTags(values) {
    var out = [];
    var seen = {};
    for (var i = 0; i < values.length; i += 1) {
      var next = normalizeTag(values[i]);
      if (!next || seen[next]) continue;
      seen[next] = true;
      out.push(next);
    }
    return out;
  }

  function parseExcludeTags(raw) {
    if (Array.isArray(raw)) return raw.slice();
    if (typeof raw === 'string') {
      if (!raw.trim()) return [];
      return raw.split(',');
    }
    return [];
  }

  function sanitizeStaticExcludeTags(values) {
    var tags = uniqueTags(values);
    var out = [];
    for (var i = 0; i < tags.length; i += 1) {
      var next = tags[i];
      if (next === EAST_EXCLUDE || next === WEST_EXCLUDE) continue;
      out.push(next);
    }
    return out;
  }

  function getRequiredExcludeTag(region) {
    if (region === 'east') return EAST_EXCLUDE;
    if (region === 'west') return WEST_EXCLUDE;
    return '';
  }

  function getGloboConfig() {
    var cfg = window.GloboEmbedFilterConfig || {};
    if (!cfg.collection || typeof cfg.collection !== 'object') {
      cfg.collection = {};
    }
    window.GloboEmbedFilterConfig = cfg;
    return cfg;
  }

  function ensureBaseExcludeTags(cfg) {
    if (baseExcludeTags) return baseExcludeTags.slice();

    var fromConfig = sanitizeStaticExcludeTags(parseExcludeTags(cfg.collection.excludeTags));
    if (!fromConfig.length) {
      fromConfig = sanitizeStaticExcludeTags(FALLBACK_STATIC_EXCLUDES);
    }

    baseExcludeTags = fromConfig.slice();
    return fromConfig.slice();
  }

  function applyRegionExcludeTags(reason) {
    var cfg = getGloboConfig();
    var base = ensureBaseExcludeTags(cfg);
    var requiredTag = getRequiredExcludeTag(currentRegion);
    var nextTags = base.slice();

    if (requiredTag) nextTags.push(requiredTag);
    nextTags = uniqueTags(nextTags);

    cfg.collection.excludeTags = nextTags.slice();

    // Keep runtime object in sync if Globo has already booted.
    if (window.globofilter && window.globofilter.collection && typeof window.globofilter.collection === 'object') {
      window.globofilter.collection.excludeTags = nextTags.slice();
    }

    lastApply.at = new Date().toISOString();
    lastApply.reason = reason || 'unknown';
    lastApply.region = currentRegion;
    lastApply.requiredTag = requiredTag;
    lastApply.excludeTags = nextTags.slice();

    logInfo('applied Globo excludeTags', {
      reason: lastApply.reason,
      region: currentRegion,
      requiredTag: requiredTag,
      excludeTags: nextTags
    });
  }

  function isGloboApiUrl(urlObj) {
    if (!urlObj || typeof urlObj.pathname !== 'string') return false;
    var host = String(urlObj.hostname || '');
    if (!GLOBO_HOST_MATCHER.test(host)) return false;

    var pathname = urlObj.pathname || '';
    for (var i = 0; i < GLOBO_API_PATH_MATCHERS.length; i += 1) {
      if (pathname.indexOf(GLOBO_API_PATH_MATCHERS[i]) !== -1) return true;
    }
    return false;
  }

  function getEffectiveExcludeTags() {
    var cfg = getGloboConfig();
    var base = ensureBaseExcludeTags(cfg);
    var requiredTag = getRequiredExcludeTag(currentRegion);
    var next = base.slice();
    if (requiredTag) next.push(requiredTag);
    return uniqueTags(next);
  }

  function mergeExcludeTagsIntoUrl(urlObj, tags) {
    var existing = [];
    urlObj.searchParams.forEach(function (value, key) {
      if (key === 'excludeTags[]' || key === 'excludeTags') {
        existing.push(value);
      }
    });

    var merged = uniqueTags(existing.concat(tags || []));

    while (urlObj.searchParams.has('excludeTags[]')) {
      urlObj.searchParams.delete('excludeTags[]');
    }
    while (urlObj.searchParams.has('excludeTags')) {
      urlObj.searchParams.delete('excludeTags');
    }

    for (var i = 0; i < merged.length; i += 1) {
      urlObj.searchParams.append('excludeTags[]', merged[i]);
    }

    return merged;
  }

  function patchGloboFetchRequests() {
    if (fetchPatched) return;
    if (typeof window.fetch !== 'function') return;

    var originalFetch = window.fetch;
    fetchPatched = true;

    window.fetch = function (input, init) {
      var shouldNudgeReveal = false;
      var isGloboRequest = false;
      try {
        var rawUrl = '';
        if (typeof input === 'string') {
          rawUrl = input;
        } else if (input && typeof input.url === 'string') {
          rawUrl = input.url;
        }

        if (rawUrl) {
          var urlObj = new URL(rawUrl, window.location.origin);
          if (isGloboApiUrl(urlObj)) {
            isGloboRequest = true;
            var requiredTag = getRequiredExcludeTag(currentRegion);
            var mergedExcludeTags = mergeExcludeTagsIntoUrl(urlObj, getEffectiveExcludeTags());
            var nextUrl = urlObj.toString();

            if (nextUrl !== rawUrl) {
              if (typeof input === 'string') {
                input = nextUrl;
              } else if (typeof Request !== 'undefined' && input instanceof Request) {
                input = new Request(nextUrl, input);
              } else {
                input = nextUrl;
              }

              lastMutation.at = new Date().toISOString();
              lastMutation.region = currentRegion;
              lastMutation.requiredTag = requiredTag;
              lastMutation.excludeTags = mergedExcludeTags.slice();
              lastMutation.url = nextUrl;

              logInfo('mutated Globo request', {
                region: currentRegion,
                requiredTag: requiredTag,
                excludeTags: mergedExcludeTags,
                url: nextUrl
              });

              if (isCollectionOrSearchPage()) {
                shouldNudgeReveal = true;
              }
            }
          }
        }
      } catch (e) {}

      if (isGloboRequest) {
        globoSawRequest = true;
        globoInFlightRequests += 1;
      }

      var result = originalFetch.call(this, input, init);

      if (result && typeof result.then === 'function') {
        result.then(function () {
          if (isGloboRequest) {
            globoInFlightRequests = Math.max(0, globoInFlightRequests - 1);
          }
          if (shouldNudgeReveal || isGloboRequest) {
            setTimeout(function () {
              maybeRevealPendingRegionUi('fetch:resolved');
            }, 0);
          }
        }).catch(function () {
          if (isGloboRequest) {
            globoInFlightRequests = Math.max(0, globoInFlightRequests - 1);
          }
          if (shouldNudgeReveal || isGloboRequest) {
            setTimeout(function () {
              maybeRevealPendingRegionUi('fetch:rejected');
            }, 0);
          }
        });
      }

      return result;
    };
  }

  function isCollectionOrSearchPage() {
    try {
      var body = document && document.body;
      if (body && body.className) {
        var cls = String(body.className);
        if (cls.indexOf('template-collection') !== -1 || cls.indexOf('template-search') !== -1) {
          return true;
        }
      }
      var path = String((window.location && window.location.pathname) || '');
      if (/\/collections(\/|$)/.test(path)) return true;
      if (/\/search(\/|$)/.test(path)) return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  function setPendingRegionUiHidden(hidden) {
    if (!isCollectionOrSearchPage()) return;
    var root = document && document.documentElement;
    if (!root) return;

    if (hidden) {
      if (!root.classList.contains('ecomific-globo-region-pending')) {
        root.classList.add('ecomific-globo-region-pending');
      }
      if (!document.getElementById('ecomific-globo-region-pending-style')) {
        var style = document.createElement('style');
        style.id = 'ecomific-globo-region-pending-style';
        style.textContent = [
          '.ecomific-globo-region-pending #gspfProduct,',
          '.ecomific-globo-region-pending #CollectionAjaxContent,',
          '.ecomific-globo-region-pending [data-section-type="collection-template"] .grid,',
          '.ecomific-globo-region-pending [data-section-type="collection-template"] .grid__item {',
          '  visibility: hidden !important;',
          '}'
        ].join('\n');
        document.head.appendChild(style);
      }
      if (pendingHideTimer) {
        clearTimeout(pendingHideTimer);
      }
      pendingHideTimer = setTimeout(function () {
        maybeRevealPendingRegionUi('pending-timeout');
      }, 4500);
      return;
    }

    root.classList.remove('ecomific-globo-region-pending');
    root.classList.remove('ecomific-globo-region-prehide');
    if (pendingHideTimer) {
      clearTimeout(pendingHideTimer);
      pendingHideTimer = null;
    }
  }

  function hasKnownRegion() {
    return !!normalizeRegion(currentRegion || readRegion());
  }

  function hasGridCards() {
    if (!document || typeof document.querySelector !== 'function') return false;
    return !!(
      document.querySelector('#CollectionAjaxContent .grid-product') ||
      document.querySelector('#CollectionAjaxContent [data-product-handle]') ||
      document.querySelector('#gspfProduct .grid-product') ||
      document.querySelector('.new-grid .grid-item') ||
      document.querySelector('.collection-grid .grid-item')
    );
  }

  function clearInitialGridObserver() {
    if (initialGridObserver) {
      try {
        initialGridObserver.disconnect();
      } catch (e) {}
      initialGridObserver = null;
    }
  }

  function maybeRevealPendingRegionUi(reason) {
    if (initialGridRevealDone) return;
    if (reloadScheduled) return;
    if (!hasKnownRegion()) return;
    if (globoSawRequest && globoInFlightRequests > 0 && reason !== 'pending-timeout') return;
    if (!hasGridCards()) return;
    initialGridRevealDone = true;
    clearInitialGridObserver();
    setPendingRegionUiHidden(false);
    logInfo('released pending region UI', {
      reason: reason || 'unknown',
      region: currentRegion || readRegion()
    });
  }

  function armInitialGridRevealWatcher() {
    if (!isCollectionOrSearchPage()) return;
    if (initialGridRevealArmed) return;
    initialGridRevealArmed = true;

    function startWatching() {
      if (initialGridRevealDone) return;
      if (typeof MutationObserver === 'undefined') {
        maybeRevealPendingRegionUi('no-observer');
        return;
      }
      var target = document.getElementById('CollectionAjaxContent') || document.body;
      if (!target) {
        return;
      }
      clearInitialGridObserver();
      initialGridObserver = new MutationObserver(function () {
        maybeRevealPendingRegionUi('mutation');
      });
      initialGridObserver.observe(target, { childList: true, subtree: true });
      maybeRevealPendingRegionUi('initial-check');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startWatching, { once: true });
      return;
    }
    startWatching();
  }

  function getReloadStorageKey() {
    var path = '/';
    try {
      path = window.location && window.location.pathname ? window.location.pathname : '/';
    } catch (e) {}
    return RELOAD_KEY_PREFIX + path;
  }

  function readReloadMarker() {
    try {
      var raw = window.sessionStorage.getItem(getReloadStorageKey());
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (typeof parsed.at !== 'number') return null;
      if ((Date.now() - parsed.at) > RELOAD_TTL_MS) {
        window.sessionStorage.removeItem(getReloadStorageKey());
        return null;
      }
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function markReload(fromRegion, toRegion) {
    try {
      window.sessionStorage.setItem(getReloadStorageKey(), JSON.stringify({
        from: fromRegion || '',
        to: toRegion || '',
        at: Date.now()
      }));
    } catch (e) {}
  }

  function maybeReloadForRegionChange(source) {
    if (!isCollectionOrSearchPage()) return false;
    if (!currentRegion) return false;

    // No reload needed if page was already loaded for this region.
    if (currentRegion === regionAtLoad) return false;

    var marker = readReloadMarker();
    if (marker && marker.from === (regionAtLoad || '') && marker.to === currentRegion) {
      return false;
    }

    markReload(regionAtLoad, currentRegion);
    reloadScheduled = true;
    logInfo('reloading page for Globo region re-init', {
      fromRegion: regionAtLoad,
      toRegion: currentRegion,
      source: source || ''
    });

    window.location.reload();
    return true;
  }

  function updateRegionFromEvent(event) {
    if (!event || !event.detail) return false;
    var next = normalizeRegion(event.detail.region || event.detail.nextRegion || '');
    if (!next) return false;

    var changed = next !== currentRegion;
    currentRegion = next;

    if (changed) {
      logInfo('region updated', {
        region: currentRegion,
        source: event.detail.source || ''
      });
    }

    return changed;
  }

  function buildQaSnapshot() {
    var cfg = getGloboConfig();
    var configuredExcludeTags = sanitizeStaticExcludeTags(parseExcludeTags(cfg.collection.excludeTags));
    var runtimeFilter = (window.globofilter && window.globofilter.filter && typeof window.globofilter.filter === 'object')
      ? window.globofilter.filter
      : {};
    var bodyClassName = '';
    try {
      bodyClassName = (document && document.body && typeof document.body.className === 'string')
        ? document.body.className
        : '';
    } catch (e) {}

    return {
      regionCurrent: currentRegion || '',
      regionAtLoad: regionAtLoad || '',
      regionFromLs: readRegionFromLs(),
      regionFromCookie: readRegionFromCookie(),
      requiredExcludeTag: getRequiredExcludeTag(currentRegion || readRegion()),
      configuredExcludeTags: configuredExcludeTags,
      baseExcludeTags: baseExcludeTags ? baseExcludeTags.slice() : [],
      lastApply: {
        at: lastApply.at,
        reason: lastApply.reason,
        region: lastApply.region,
        requiredTag: lastApply.requiredTag,
        excludeTags: (lastApply.excludeTags || []).slice()
      },
      lastMutation: {
        at: lastMutation.at,
        region: lastMutation.region,
        requiredTag: lastMutation.requiredTag,
        excludeTags: (lastMutation.excludeTags || []).slice(),
        url: lastMutation.url
      },
      globo: {
        filterId: (cfg.filter && cfg.filter.id) || runtimeFilter.id || null,
        layout: (cfg.filter && cfg.filter.layout) || runtimeFilter.layout || null,
        sublayout: (cfg.filter && cfg.filter.sublayout) || runtimeFilter.sublayout || null,
        hasProductsTemplate: !!document.getElementById('gspfProduct'),
        hasTreeTemplate: !!document.getElementById('gspfFilterTree'),
        hasSortTemplate: !!document.getElementById('gspfFilterSort'),
        hasSearchTemplate: !!document.getElementById('gspfSearchResult'),
        hasPaginationTemplate: !!document.getElementById('gspfPagination'),
        hasYmmTemplate: !!document.getElementById('gspfForm')
      },
      pageUi: {
        hasSpfLayoutThemeClass: bodyClassName.indexOf('spf-layout-theme') !== -1,
        hasSpfHasFilterClass: bodyClassName.indexOf('spf-has-filter') !== -1,
        themeStoreClass: (bodyClassName.match(/theme-store-id-\d+/) || [null])[0]
      },
      requestState: {
        globoSawRequest: globoSawRequest,
        globoInFlightRequests: globoInFlightRequests,
        reloadScheduled: reloadScheduled
      },
    };
  }

  window.ecomificGloboQa = function () {
    var snapshot = buildQaSnapshot();
    if (window.console && console.log) {
      console.log('[ecomific] globo-qa', snapshot);
    }
    return snapshot;
  };

  if (isCollectionOrSearchPage()) {
    setPendingRegionUiHidden(true);
    armInitialGridRevealWatcher();
  }

  patchGloboFetchRequests();
  applyRegionExcludeTags('init');

  window.addEventListener('ecomific:region:ready', function (event) {
    var changed = updateRegionFromEvent(event);
    if (!changed) return;
    applyRegionExcludeTags('region:ready');
    if (maybeReloadForRegionChange(event && event.detail ? event.detail.source : '')) return;
    maybeRevealPendingRegionUi('region:ready');
  });

  window.addEventListener('ecomific:region:set-request', function (event) {
    var changed = updateRegionFromEvent(event);
    if (!changed) return;
    applyRegionExcludeTags('region:set-request');
    if (maybeReloadForRegionChange(event && event.detail ? event.detail.source : '')) return;
    maybeRevealPendingRegionUi('region:set-request');
  });

  window.addEventListener('ecomific:region:changed', function (event) {
    var changed = updateRegionFromEvent(event);
    if (!changed) return;

    applyRegionExcludeTags('region:changed');
    if (maybeReloadForRegionChange(event && event.detail ? event.detail.source : '')) return;
    maybeRevealPendingRegionUi('region:changed');
  });

  logInfo('initialized', {
    regionAtLoad: regionAtLoad || '',
    regionCurrent: currentRegion || ''
  });
})();
